import { z } from "zod";
import type { infer as zInfer } from "zod/lib/types";

export const outcome = z.object({
  abbreviation: z.string().nullish(),
  active: z.boolean(),
  attributes: z.record(z.string(), z.string()),
  closingOdds: z.number().optional(),
  name: z.string(),
  odds: z.number(),
  openingOdds: z.number().optional(),
  result: z.enum(["VOID", "WIN", "LOSE", "UNDECIDED"]),
  type: z.enum([
    "FRANCHISE",
    "FRANCHISE_HOME",
    "FRANCHISE_AWAY",

    "PLAYER",
    "PLAYER_HOME",
    "PLAYER_AWAY",

    "YES",
    "NO",
    "ODD",
    "EVEN",
    "DRAW",
    "NO_DRAW",
    "OVER",
    "UNDER",
    "EQUAL",
    "OTHER",

    "CORRECT_SCORE",
    "TOTAL_POINTS",
    "EXACT_GOALS",
    "WINNING_MARGIN",
    "DOUBLE_RESULT",
    "EXACT_SETS",
    "EXACT_GAMES",

    "FIRST_HALF",
    "SECOND_HALF",
    "FIRST_QUARTER",
    "SECOND_QUARTER",
    "THIRD_QUARTER",
    "FORTH_QUARTER",

    "RUNNER_WIN",
    "RUNNER_TOP_2",
    "RUNNER_TOP_3",
    "RUNNER_TOP_4",
    "RUNNER_POS_2",
    "RUNNER_POS_3",
    "RUNNER_POS_4",

    "DRAGON_TYPE",
    "RUNE_TYPE",

    "NONE",
    "UNKNOWN",
  ]),
  competitorId: z.string().optional(),
});

export type Outcome = zInfer<typeof outcome>;
